"use strict";exports.__esModule = true;exports.default = void 0;var eventUtils = _interopRequireWildcard(require("../../common/event-utils"));function _getRequireWildcardCache(nodeInterop) {if (typeof WeakMap !== "function") return null;var cacheBabelInterop = new WeakMap();var cacheNodeInterop = new WeakMap();return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {return nodeInterop ? cacheNodeInterop : cacheBabelInterop;})(nodeInterop);}function _interopRequireWildcard(obj, nodeInterop) {if (!nodeInterop && obj && obj.__esModule) {return obj;}if (obj === null || typeof obj !== "object" && typeof obj !== "function") {return { default: obj };}var cache = _getRequireWildcardCache(nodeInterop);if (cache && cache.has(obj)) {return cache.get(obj);}var newObj = {};var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;for (var key in obj) {if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;if (desc && (desc.get || desc.set)) {Object.defineProperty(newObj, key, desc);} else {newObj[key] = obj[key];}}}newObj.default = obj;if (cache) {cache.set(obj, newObj);}return newObj;}var _default =

{
  handleClick(originalEvent) {
    if (!this.input.disabled) {
      this.emit('click', { originalEvent });
    }
  },

  handleKeydown(originalEvent) {
    eventUtils.handleEscapeKeydown(originalEvent, () => {
      if (!this.input.disabled) {
        this.emit('escape', { originalEvent });
      }
    });
  },
  handleFocus(originalEvent) {
    this.emit('focus', { originalEvent });
  },
  handleBlur(originalEvent) {
    this.emit('blur', { originalEvent });
  }
};exports.default = _default;module.exports = exports.default;